module.exports = __webpack_public_path__ + "static/media/allergy_slider_phone2.718c0731.png";